import { OBJECT_TYPE } from '../constants/objectTypes';
import { getTeamIdsRpc, updateTeamIdsRpc } from '../../__generated__/chirp/com/hubspot/marketing/asset/permissions/rpc/TeamPermissionsRpc';
import { getUserIdsRpc, updateUserIdsRpc } from '../../__generated__/chirp/com/hubspot/marketing/asset/permissions/rpc/UserPermissionsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import appAuthApiClient from 'hub-http/clients/apiClient';
const rpcClient = createRpcClientV2({
  hubHttpClient: appAuthApiClient
});

// TODO: Add correct manage access api calls for other object types

export function getTeamPermissions({
  objectType,
  objectId
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return rpcClient.call(getTeamIdsRpc, {
        request: {
          objectTypeId: objectType,
          assetId: Number(objectId)
        }
      }).then(result => result.teamIds || []);
    default:
      return Promise.resolve([]);
  }
}
export function getUserPermissions({
  objectType,
  objectId
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return rpcClient.call(getUserIdsRpc, {
        request: {
          objectTypeId: objectType,
          assetId: Number(objectId)
        }
      }).then(result => result.userIds || []);
    default:
      return Promise.resolve([]);
  }
}
export function saveTeamPermissions({
  objectType,
  objectId,
  teamIds
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return rpcClient.call(updateTeamIdsRpc, {
        request: {
          objectTypeId: objectType,
          assetIds: [Number(objectId)],
          teamIds
        }
      }).then(() => teamIds);
    default:
      return Promise.resolve([]);
  }
}
export function saveUserPermissions({
  objectType,
  objectId,
  userIds
}) {
  switch (objectType) {
    case OBJECT_TYPE.CAMPAIGN:
      return rpcClient.call(updateUserIdsRpc, {
        request: {
          objectTypeId: objectType,
          assetIds: [Number(objectId)],
          userIds
        }
      }).then(() => userIds);
    default:
      return Promise.resolve([]);
  }
}